import {
  BookmarkIcon,
  ChatBubbleOvalLeftEllipsisIcon as ChatIcon,
  HeartIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolidIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";

const ProjectDetail = ({ project, onClose }) => {
  const [isLiked, setIsLiked] = useState(false);
  const [likes, setLikes] = useState(project.likes || 0);
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState(project.comments || []);

  const handleLike = () => {
    if (isLiked) {
      setLikes(likes - 1);
    } else {
      setLikes(likes + 1);
    }
    setIsLiked(!isLiked);
  };

  const handleComment = (e) => {
    e.preventDefault();
    if (comment.trim()) {
      setComments([...comments, { user: "You", text: comment }]);
      setComment("");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="bg-white dark:bg-gray-950  rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-semibold ">{project.caption}</h2>
          <button onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="flex flex-col md:flex-row">
          <img
            src={project.image}
            alt={project.caption}
            className="object-cover w-full md:w-1/2"
          />
          <div className="w-full p-4 md:w-1/2">
            <p className="mb-4">{project.description}</p>
            <div className="flex items-center justify-between mb-4">
              <div className="flex space-x-4">
                <button onClick={handleLike}>
                  {isLiked ? (
                    <HeartSolidIcon className="w-6 h-6 text-red-500" />
                  ) : (
                    <HeartIcon className="w-6 h-6" />
                  )}
                </button>
                <ChatIcon className="w-6 h-6" />
                <PaperAirplaneIcon className="w-6 h-6" />
              </div>
              <BookmarkIcon className="w-6 h-6" />
            </div>
            <p className="mb-2 font-semibold">{likes} likes</p>
            <div className="mb-4 overflow-y-auto max-h-40">
              {comments.map((comment, index) => (
                <p key={index}>
                  <span className="font-semibold">{comment.user}</span>{" "}
                  {comment.text}
                </p>
              ))}
            </div>
            <form onSubmit={handleComment} className="flex items-center">
              <input
                type="text"
                placeholder="Add a comment..."
                className="flex-grow p-2 border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 dark:bg-gray-800"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <button
                type="submit"
                className="px-4 py-2 ml-2 text-white bg-blue-500 rounded-md"
              >
                Post
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
